export function switchImgOnHover(wrapper = document) {
    for(const switchImgOnHoverTarget of wrapper.querySelectorAll(".js-switch-img-on-hover")){
        const hoverImg = switchImgOnHoverTarget.dataset.imgHover;
        if(hoverImg){
            switchImgOnHoverTarget.style.transition = "opacity 0.1s linear";

            switchImgOnHoverTarget.addEventListener("mouseenter", function(){
                switchImgOnHoverTarget.dataset.imgOriginal = switchImgOnHoverTarget.src;
                switchImgOnHoverTarget.style.opacity = "0";
                setTimeout(() => {
                    switchImgOnHoverTarget.src = hoverImg;
                    switchImgOnHoverTarget.style.opacity = "1";
                }, 100);
            });
            switchImgOnHoverTarget.addEventListener("mouseleave", function(){
                switchImgOnHoverTarget.style.opacity = "0";
                setTimeout(() => {
                    switchImgOnHoverTarget.src = switchImgOnHoverTarget.dataset.imgOriginal;
                    switchImgOnHoverTarget.style.opacity = "1";
                }, 100);
            });
        }
    }
}